import { render, staticRenderFns } from "./MeetingCommentMobile.vue?vue&type=template&id=36df7dc8&scoped=true"
import script from "./MeetingCommentMobile.vue?vue&type=script&lang=js"
export * from "./MeetingCommentMobile.vue?vue&type=script&lang=js"
import style0 from "./MeetingCommentMobile.vue?vue&type=style&index=0&id=36df7dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df7dc8",
  null
  
)

export default component.exports